<template>
	<div class="container-fluid">
		<!-- row1 -->
		<div class="row d-flex">
			<div class="col-12">
				<div class="row py-2">
					<h2 class="mb-0 text-gray">
						<i class="bi bi-pie-chart me-3"></i>
						Lead Status
					</h2>
				</div>
				<div class="row mb-4 justify-content-between">
					<DashInfoComponent
						name="Total Leads"
						:info="data.stats?.total"
						icon="bi bi-ui-checks-grid"
						classes="col-6 blue-gradient text-white"
					/>
					<DashInfoComponent
						name="Hot Leads"
						:info="data.stats?.hot"
						icon="bi bi-brightness-high"
						classes="col-6 yellow-gradient text-white"
					/>
					<DashInfoComponent
						name="Cold Leads"
						:info="data.stats?.cold"
						icon="bi bi-clipboard2-minus"
						classes="col-6 orange-gradient text-white"
					/>
					<DashInfoComponent
						name="Warm Leads"
						:info="data.stats?.warm"
						icon="bi bi-brightness-low"
						classes="col-6 green-gradient text-white"
					/>
				</div>
			</div>
			<div class="col-12">
				<div class="row py-2">
					<h2 class="mb-0 text-gray">
						<i class="bi bi-file-text me-3"></i>
						Lead Report
					</h2>
				</div>
				<div class="row mb-4 justify-content-between">
					<DashInfoComponent
						name="New Leads"
						:info="data.stats?.new"
						icon="bi bi-clipboard-plus"
						classes="col-6 blue-border text-blue"
					/>
					<DashInfoComponent
						name="Active Leads"
						:info="data.stats?.active"
						icon="bi bi-arrow-down-up"
						classes="col-6 yellow-border text-yellow"
					/>
					<DashInfoComponent
						name="Booked Leads"
						:info="data.stats?.booked"
						icon="bi bi-check2-all"
						classes="col-6 orange-border text-orange"
					/>
					<DashInfoComponent
						name="Lost Leads"
						:info="data.stats?.lost"
						icon="bi bi-graph-down-arrow"
						classes="col-6 green-border text-green"
					/>
				</div>
			</div>
		</div>

		<!-- row2 -->
		<div class="row d-flex">
			<div class="bar-chart col-sm-12 col-md-5 my-4 py-4">
				<MonthlyChartsApex />
			</div>
			<div class="col-sm-12 col-md-6 custom-rounded-15 shadow-md my-4 py-4">
				<h2 class="mb-0 custom-blue mt-3 note-text">
					<i class="bi bi-calendar-event custom-blue me-3"></i> Upcoming Travel
				</h2>

				<div class="container custom-height overflow-auto">
					<div class="row">
						<table v-if="data.upcomingTravel.length" class="container">
							<tr class="table-background-blue">
								<th class="text-gray">
									<b class="text-blue">Lead Number</b>
								</th>
								<th class="text-gray">
									<b class="text-blue">Customer</b>
								</th>
								<th class="text-dar">
									<b class="text-blue">Date</b>
								</th>
								<!-- <th class="text-dar">
									<b class="text-blue">Contact</b>
								</th>
								<th class="text-dar">
									<b class="text-blue">Email</b>
								</th> -->
							</tr>

							<tr
								v-for="(travel, index) in data.upcomingTravel"
								:key="`today-${index}`"
								class="my-1"
								role="alert"
							>
								<td class="text-gray">{{ travel.leadNumber }}</td>

								<td class="text-gray">
									{{ travel.name.salutation }}
									{{ travel.name.firstName }}
									{{ travel.name.lastName }}
								</td>
								<td class="text-gray">
									{{
										new Intl.DateTimeFormat("en-US", {
											timeZone: "Asia/Kolkata",
											dateStyle: "medium",
											timeStyle: "short",
										})
											.format(
												new Date(travel?.startDate.split("T")[0]) -
													new Date(18000000 + 1800000),
											)
											.toString()
											.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
									}}
								</td>
								<!-- <td class="text-gray">
									{{ travel.phone }}
								</td>
								<td class="text-gray">
									{{ travel.email }}
								</td> -->
							</tr>
						</table>
						<div v-else class="container">
							<h4 class="text-gray">No Upcoming Travel!</h4>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- row3 -->
		<div class="row">
			<div class="col-sm-12 col-md-4 mt-4">
				<div class="Reminders">
					<div class="col-sm-12 p-2 custom-rounded-15 shadow-md mb-1 mt-2">
						<h2 class="mb-0 text-green mt-3 note-text border-dark">
							<i class="bi bi-calendar-event text-green me-3"></i> Reminders
						</h2>
						<div class="container overflow-auto custom-height">
							<div class="row">
								<div v-if="data.reminderToday.length" class="container">
									<ReminderDetails :data="data.reminderToday" type="Today" />
								</div>
								<div v-else class="container">
									<h4 class="text-green">No Reminders for today !</h4>
								</div>
							</div>
						</div>
						<div class="container custom-border-top">
							<div class="row">
								<div v-if="data.reminderUpcoming.length" class="container">
									<ReminderDetails
										:data="data.reminderUpcoming"
										type="Upcoming"
									/>
								</div>
								<div v-else class="container py-4">
									<h4 class="text-gray">No Upcoming Reminders !</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-sm-12 col-md-4 mt-4">
				<div class="Notes">
					<!-- <div class="row spacing"> -->
					<div class="row p-2">
						<div class="notes col-12 mt-2 pb-3 custom-rounded-15">
							<h2 class="mb-0 text-yellow mt-3 mt-2 note-text">
								<i class="bi bi-calendar-event text-yellow"></i> Notes
							</h2>
							<div class="overflow-x-hidden overflow-y-auto custom-height">
								<table v-if="data.notes.length" class="">
									<tr class="border-info table-background-yellow">
										<th class="text-yellow" style="width: 100px">
											<b>Lead Number</b>
										</th>
										<th class="text-yellow">
											<b>Note</b>
										</th>
									</tr>
									<tr
										v-for="(note, index) in data.notes"
										:key="`today-${index}`"
										class="alert my-1"
										role="alert"
									>
										<td class="text-gray">{{ note.leadNumber }}</td>
										<td
											v-for="(data, index) in note.notes"
											:key="`note-${index}`"
											class="text-gray d-flex"
										>
											{{ data.string }} @
											{{
												new Intl.DateTimeFormat("en-US", {
													timeZone: "Asia/Kolkata",
													dateStyle: "medium",
													timeStyle: "short",
												})
													.format(
														new Date(data.date.split("T")[0]) -
															new Date(18000000 + 1800000),
													)
													.toString()
													.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
											}}
										</td>
									</tr>
								</table>
								<div v-else class="container">
									<h4 class="text-gray">No Notes!</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-sm-12 col-md-4 mt-4">
				<div class="Users">
					<div class="row py-2 px-2 text-gray mb-1">
						<h2 class="mb-0 text-gray">
							<i class="bi bi-person me-3"></i>
							Users
						</h2>
					</div>
					<div class="row my-2">
						<div class="col-12 px-4 mb-3">
							<div
								class="row custom-rounded-15 custom-blue-light-bg custom-blue-text py-4 px-1 user-padding"
							>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<i class="bi bi-person-check fs-2"></i>
								</div>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<p class="fs-4 mb-0">Active Users</p>
								</div>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<span class="fs-2">
										{{ data.userStats?.active || "-" }}
									</span>
								</div>
							</div>
						</div>

						<div class="col-12 px-4">
							<div
								class="row custom-rounded-15 custom-orange-light-bg custom-orange-text py-4 px-1 user-padding"
							>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<i class="bi bi-person-x fs-2"></i>
								</div>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<p class="fs-4 mb-0">Inactive Users</p>
								</div>
								<div
									class="col-sm-4 d-flex justify-content-center align-items-center"
								>
									<span class="fs-2">
										{{ data.userStats?.inActive || "-" }}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- row4 -->
		<div class="row d-flex mt-5">
			<div class="col-sm-12 col-md-4">
				<div
					class="col-12 py-2 px-2 div-height custom-rounded-15 shadow-md mb-1 mt-5"
				>
					<div class="Birthday">
						<h2 class="mb-0 text-orange mt-3 note-text">
							<i class="bi bi-calendar-event text-orange me-3"></i> Upcoming
							Birthdays
						</h2>

						<div class="container custom-height">
							<div class="row custom-height">
								<div
									v-if="data.birthdays.length"
									class="container custom-height overflow-auto"
								>
									<table class="alert my-1 w-100" role="alert">
										<tr class="table-background-orange">
											<th class="text-orange rightpadding">
												<b>Customer</b>
											</th>
											<th class="text-orange rightpadding">
												<b>Date</b>
											</th>
											<!-- <th class="text-orange rightpadding">
												<b>Contact</b>
											</th>
											<th class="text-orange rightpadding">
												<b>Email</b>
											</th> -->
										</tr>
										<tr
											v-for="birthday in data.birthdays"
											:key="birthday._id"
											class="border-info"
										>
											<td class="text-gray rightpadding">
												{{ birthday.name.salutation }}
												{{ birthday.name.firstName }}
												{{ birthday.name.lastName }}
											</td>
											<td class="text-gray rightpadding">
												{{
													new Intl.DateTimeFormat("en-US", {
														timeZone: "Asia/Kolkata",
														dateStyle: "medium",
														timeStyle: "short",
													})
														.format(
															new Date(birthday?.dateOfBirth.split("T")[0]) -
																new Date(18000000 + 1800000),
														)
														.toString()
														.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
												}}
											</td>
											<!-- <td class="text-gray rightpadding">
												{{ birthday.phone }}
											</td>
											<td class="text-gray rightpadding">
												{{ birthday.email }}
											</td> -->
										</tr>
									</table>
								</div>
								<div v-else class="container">
									<h4 class="text-gray">No Upcoming Birthdays!</h4>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-sm-12 col-md-4">
				<div class="Anniversaries">
					<div
						class="col-12 py-2 px-2 custom-rounded-15 div-height shadow-md mb-1 mt-5"
					>
						<h2 class="mb-0 text-orange mt-3 note-text">
							<i class="bi bi-calendar-event text-orange me-3"></i> Upcoming
							Anniversaries
						</h2>
						<div class="container">
							<div class="row">
								<div class="container custom-height overflow-auto">
									<table
										v-if="data.anniversaries.length"
										class="alert my-1 w-100"
										role="alert"
									>
										<tr class="table-background-orange">
											<th class="text-orange rightpadding">
												<b>Customer</b>
											</th>

											<th class="text-orange rightpadding">
												<b>Date</b>
											</th>

											<!-- <th class="text-orange rightpadding">
												<b>Contact</b>
											</th>
											<th class="text-orange rightpadding">
												<b>Email</b>
											</th> -->
										</tr>
										<tr
											v-for="anniversary in data.anniversaries"
											:key="anniversary._id"
											class="border-info"
										>
											<td class="text-gray rightpadding">
												{{ anniversary.name.salutation }}
												{{ anniversary.name.firstName }}
												{{ anniversary.name.lastName }}
											</td>
											<td class="text-gray rightpadding">
												{{
													new Intl.DateTimeFormat("en-US", {
														timeZone: "Asia/Kolkata",
														dateStyle: "medium",
														timeStyle: "short",
													})
														.format(
															new Date(anniversary?.anniversary.split("T")[0]) -
																new Date(18000000 + 1800000),
														)
														.toString()
														.replace(/([,]\s[1][2][:][0][0])\s\w+/g, "")
												}}
												13 Jun 2022
											</td>
											<!-- <td class="text-gray rightpadding">
												{{ anniversary.phone }}
											</td>
											<td class="text-gray rightpadding">
												{{ anniversary.email }}
											</td> -->
										</tr>
									</table>
									<div v-else class="container">
										<h4 class="text-gray">No Upcoming anniversaries!</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-4"></div>
		</div>
	</div>
</template>
<script>
	import { reactive, inject, onMounted } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import toast from "@/config/toast";

	import DashInfoComponent from "@/components/DashInfoComponent";
	import ReminderDetails from "@/components/ReminderDetails";
	import MonthlyChartsApex from "@/components/MonthlyChartsApex.vue";

	export default {
		name: "Dashboard",
		components: {
			DashInfoComponent,
			ReminderDetails,
			MonthlyChartsApex,
		},
		setup: () => {
			const store = inject("store");
			// const socket = inject("socket");
			// const notifications = inject("notifications");
			const router = useRouter();

			const data = reactive({
				stats: {},
				reminderToday: [],
				reminderUpcoming: [],
				notes: [],
				upcomingTravel: [],
				userStats: {},
				birthdays: [],
				anniversaries: [],
			});
			if (!store.state.auth.isAuth) router.push("Login");

			const getStats = async () => {
				try {
					const response = await API.privateRequest.get("leads/stats");
					data.stats = response.data.data[0];
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
						console.log("set up error -1");
					}

					toast.error(message, true);
				}
			};

			const getDashLeadStats = async () => {
				try {
					const response = await API.privateRequest.get(
						`dashLeadStats/${store.state.user.id}`,
					);
					data.reminderToday = response.data.data[0].reminders.filter(
						(reminderObj) =>
							reminderObj.reminder.date.split("T")[0] ===
							new Date().toISOString().split("T")[0],
					);
					data.reminderUpcoming = response.data.data[0].reminders.filter(
						(reminderObj) =>
							reminderObj.reminder.date.split("T")[0] !==
							new Date().toISOString().split("T")[0],
					);
					data.notes = response.data.data[0].notes;
					data.upcomingTravel = response.data.data[0].upcomingTravel.map(
						(travel) => {
							travel.startDate =
								travel.packageStartDate || travel.flightStartDate[0];

							return travel;
						},
					);
					data.birthdays = response.data.data[0].birthdays;
					data.anniversaries = response.data.data[0].anniversaries;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
						console.log("set up error -2");
					}

					toast.error(message, true);
				}
			};

			const userStats = async () => {
				try {
					const response = await API.privateRequest.get(`users/stats`);

					data.userStats = {
						...response.data.data[0],
						inActive:
							response.data.data[0].total - response.data.data[0].active,
					};
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
						console.log("set up error -1");
					}

					toast.error(message, true);
				}
			};

			onMounted(() => {
				getStats();
				getDashLeadStats();
				userStats();
			});

			return {
				data,
			};
		},
	};
</script>

<style scoped>
	.custom-height {
		max-height: 200px;
	}
	.h2,
	h2 {
		font-size: 1.4rem;
	}
	.custom-blue-text {
		box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
			rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
	}
	.custom-orange-text {
		box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
			rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
	}
	.fs-4 {
		font-size: 1.2rem !important;
	}
	.notes {
		box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
			rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
	}
	.note-text {
		padding-bottom: 10px;
	}
	.border-info p {
		color: rgba(4, 4, 4) !important;
	}
	.h4,
	h4 {
		font-size: 1rem;
	}
	.custom-border-top {
		border-top: 1px solid #0dcaf0 !important;
	}
	.bar-chart {
		box-shadow: rgb(9 30 66 / 25%) 0px 4px 8px -2px,
			rgb(9 30 66 / 8%) 0px 0px 0px 1px;
		border-radius: 10px;
	}
	.line-bottom {
		border-bottom: 1px solid #000;
	}
	.row {
		display: flex;
		justify-content: space-around;
	}
	.row.spacing {
		margin-left: 30px;
		margin-right: 15px;
	}
	.div-height {
		height: 300px;
	}
	.user-padding {
		padding: 37px 0px !important;
	}
	.rightpadding {
		padding-right: 8px;
	}
</style>